import { Tiers, TierTeam } from "@eventr/common";
import { ColoursObj, MenuButton, Typography } from "@eventr/common-storybook";
import { useGlobalRouter } from "feat/globalRouter/useGlobalRouter";
import { paywallAvailable, presentUpgradePaywall } from "feat/revenueCat/upgrade";
import { accountTranslation } from "i18n/translateHelpers";
import { useCallback, useMemo } from "react";
import { routes } from "routing";
import { useBoundStore } from "state/bound.store";
import { useIsOwner } from "state/hooks/useIsOwner";
import { defaultAddSnack } from "state/overlayState/overlayContext";
import { getTagColour } from "v2/v2Utils";
import { useShallow } from "zustand/react/shallow";

export const showOnlyOwnerCanDo = () => {
  defaultAddSnack(accountTranslation("Only owner can upgrade"), "info");
};

export const AccountEventRProButton = () => {
  const { pushPath } = useGlobalRouter();

  const { tier, subscriptionIsPaused, org } = useBoundStore(
    useShallow((s) => ({
      tier: s.tier,
      subscriptionIsPaused: s.orgConfig.subscriptionStatus === "mobile_paused",
      org: s.selectedOrg,
    })),
  );

  const isOwner = useIsOwner();

  const onClick = useCallback(async () => {
    if (tier === TierTeam.id) {
      if (!isOwner) {
        showOnlyOwnerCanDo();
        return;
      }
      if (subscriptionIsPaused) {
        window.location.href = "https://play.google.com/store/account/subscriptions";
        return;
      }
      await presentUpgradePaywall();
    } else {
      pushPath(routes.account.subscription.path, { animation: "left" });
    }
  }, [tier, pushPath, isOwner, subscriptionIsPaused]);

  const label = useMemo(() => {
    if (subscriptionIsPaused) {
      return accountTranslation("Unpause Team Plus");
    }

    const tierObj = Tiers[tier ?? TierTeam.id];
    if (tier === TierTeam.id) {
      return accountTranslation("Upgrade to Team Plus");
    }
    return tierObj?.name ?? tier;
  }, [tier, subscriptionIsPaused]);

  const shouldShow = useMemo(() => !!org && paywallAvailable(), [org]);

  if (!shouldShow) return null;

  return (
    <MenuButton
      id="eventrProButton"
      onClick={onClick}
      endIcon="Chevron_Right"
      endIconColour="#0A1F41"
      style={{
        background: `linear-gradient(88.71deg, ${getTagColour("Magenta")} 0.86%, #FFFFFF 110.11%)`,
      }}
    >
      <Typography
        variant="bodyRegular"
        color={ColoursObj.shades.shade5}
        style={{
          textAlign: "left",
          display: "block",
        }}
      >
        {label}
      </Typography>
    </MenuButton>
  );
};
